import { useLoaderData, useParams } from 'react-router-dom';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getQuote, loader } from '../../routes/step';

const useQuote = () => {
  const { quoteId } = useLoaderData() as Awaited<ReturnType<ReturnType<typeof loader>>>;
  const { step } = useParams();

  return useSuspenseQuery(getQuote(quoteId, step));
};

export default useQuote;
